module.exports = "/images/lena-2.webp?fbaafc65ab392605973e6f35a30e6cab";